<template>
  <div>
    <sweet-modal :title="title" width="800" blocking ref="modal">
      <slot></slot>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  export default {
    name: 'info-modal',
    components: {
      SweetModal,
    },
    props: {
      title: {
        type: String,
        default: 'Title'
      }
    },
    methods: {
      openModal() {
        this.$refs.modal.open()
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>